class CategorySidebar {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    this.setupInitialState();
    this.handleURLParams();
  }

  bindEvents() {
    // Bind events for main category headers - only toggle when clicking the icon
    document.querySelectorAll('.category-header').forEach(header => {
      const categoryContent = header.nextElementSibling;
      const toggleIcon = header.querySelector('.toggle-icon');
      
      if (categoryContent && categoryContent.classList.contains('category-content') && toggleIcon) {
        // Only bind click event to the toggle icon, not the entire header
        toggleIcon.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggleCategory(header, categoryContent);
        });
      }
    });

    // Bind events for subcategory headers - only toggle when clicking the icon
    document.querySelectorAll('.subcategory-header').forEach(header => {
      const subcategoryContent = header.nextElementSibling;
      const toggleIcon = header.querySelector('.toggle-icon');
      
      if (subcategoryContent && subcategoryContent.classList.contains('subcategory-content') && toggleIcon) {
        // Only bind click event to the toggle icon, not the entire header
        toggleIcon.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggleSubcategory(header, subcategoryContent);
        });
      }
    });
  }

  toggleCategory(header, content) {
    const isActive = header.classList.contains('active');
    const toggleIcon = header.querySelector('.toggle-icon');

    if (isActive) {
      header.classList.remove('active');
      content.classList.remove('show');
      if (toggleIcon) {
        toggleIcon.textContent = '+';
      }
    } else {
      header.classList.add('active');
      content.classList.add('show');
      if (toggleIcon) {
        toggleIcon.textContent = '-';
      }
    }

    this.updateURLParams(header.dataset.category, !isActive);
  }

  toggleSubcategory(header, content) {
    const isActive = header.classList.contains('active');
    const toggleIcon = header.querySelector('.toggle-icon');

    if (isActive) {
      header.classList.remove('active');
      content.classList.remove('show');
      if (toggleIcon) {
        toggleIcon.textContent = '+';
      }
    } else {
      header.classList.add('active');
      content.classList.add('show');
      if (toggleIcon) {
        toggleIcon.textContent = '-';
      }
    }
  }

  openCategory(header) {
    const categoryContent = header.nextElementSibling;
    if (categoryContent && categoryContent.classList.contains('category-content')) {
      header.classList.add('active');
      categoryContent.classList.add('show');
      const toggleIcon = header.querySelector('.toggle-icon');
      if (toggleIcon) {
        toggleIcon.textContent = '-';
      }
    }
  }

  closeCategory(header) {
    const categoryContent = header.nextElementSibling;
    if (categoryContent && categoryContent.classList.contains('category-content')) {
      header.classList.remove('active');
      categoryContent.classList.remove('show');
      const toggleIcon = header.querySelector('.toggle-icon');
      if (toggleIcon) {
        toggleIcon.textContent = '+';
      }
    }
  }

  setupInitialState() {
    // Set initial aria attributes
    document.querySelectorAll('.category-header').forEach(header => {
      const categoryContent = header.nextElementSibling;
      const isActive = header.classList.contains('active');
      
      header.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      
      if (categoryContent && categoryContent.classList.contains('category-content')) {
        categoryContent.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      }
    });

    // Set initial aria attributes for subcategories
    document.querySelectorAll('.subcategory-header').forEach(header => {
      const subcategoryContent = header.nextElementSibling;
      const isActive = header.classList.contains('active');
      
      header.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      
      if (subcategoryContent && subcategoryContent.classList.contains('subcategory-content')) {
        subcategoryContent.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      }
    });

    // Check URL parameters for active categories
    this.checkActiveCategories();
  }

  handleURLParams() {
    const urlParams = new URLSearchParams(window.location.search);
    
    // Handle category expansion based on URL
    const categoryParam = urlParams.get('category');
    if (categoryParam) {
      const categoryHeader = document.querySelector(`[data-category="${categoryParam}"]`);
      if (categoryHeader) {
        this.openCategory(categoryHeader);
      }
    }
  }

  checkActiveCategories() {
    // Check for active category based on current page
    const currentPath = window.location.pathname;
    document.querySelectorAll('.subcategory-list a, .sub-subcategory-list a').forEach(link => {
      if (link.getAttribute('href') === currentPath) {
        link.classList.add('active');
        
        // Expand parent category
        const categoryItem = link.closest('.category-item');
        const categoryHeader = categoryItem.querySelector('.category-header');
        if (categoryHeader) {
          this.openCategory(categoryHeader);
        }

        // Expand parent subcategory if needed
        const subcategoryItem = link.closest('.subcategory-item');
        if (subcategoryItem) {
          const subcategoryHeader = subcategoryItem.querySelector('.subcategory-header');
          const subcategoryContent = subcategoryHeader.nextElementSibling;
          if (subcategoryContent && subcategoryContent.classList.contains('subcategory-content')) {
            subcategoryHeader.classList.add('active');
            subcategoryContent.classList.add('show');
            const toggleIcon = subcategoryHeader.querySelector('.toggle-icon');
            if (toggleIcon) {
              toggleIcon.textContent = '-';
            }
          }
        }
      }
    });
  }

  // Public method to programmatically open a category
  openCategoryByName(categoryName) {
    const categoryHeader = document.querySelector(`[data-category="${categoryName}"]`);
    if (categoryHeader) {
      this.openCategory(categoryHeader);
    }
  }

  // Public method to close all categories
  closeAllCategories() {
    document.querySelectorAll('.category-header.active').forEach(header => {
      this.closeCategory(header);
    });
  }

  // Public method to refresh the sidebar (useful after menu updates)
  refresh() {
    this.init();
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.categorySidebar = new CategorySidebar();
});

// Handle browser back/forward buttons
window.addEventListener('popstate', () => {
  if (window.categorySidebar) {
    window.categorySidebar.handleURLParams();
  }
});

// Export for potential use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = CategorySidebar;
}
